export default "__VITE_ASSET__h1IZ6nn7__"